import PropTypes from 'prop-types';

export const Props = {
  onClose: PropTypes.func.isRequired,
};

export const DefaultProps = {};
